import React from 'react';
import PropTypes from 'prop-types';
import Styles from './BluePanel.module.scss';

const BluePanel = ({ children }) => (
  <div className={Styles.panel}>{children}</div>
);

BluePanel.propTypes = {
  children: PropTypes.any
};

export default BluePanel;
